/** Human-readable labels for document type slugs (URL and backend formats). */

export const RESUME_DISPLAY_NAME = 'Resume & Cover\u00A0Letter';

export const DOC_TYPE_DISPLAY_NAMES = {
  resume: RESUME_DISPLAY_NAME,
  cover_letter: 'Cover Letter',
  invoice: 'Invoice',
  quotation: 'Quotation',
  waybill: 'Waybill',
  delivery_note: 'Delivery Note',
  proforma_invoice: 'Proforma Invoice',
  purchase_order: 'Purchase Order',
  business_proposal: 'Business Proposal',
  business_grant_proposal: 'Business Grant Proposal',
  ngo_grant_proposal: 'NGO Grant Proposal',
  service_proposal: 'Service Proposal',
  business_plan: 'Business Plan',
  business_plan_funding: 'Business Plan',
  // hyphenated URL slugs
  'delivery-note': 'Delivery Note',
  'proforma-invoice': 'Proforma Invoice',
  'purchase-order': 'Purchase Order',
  'business-proposal': 'Business Proposal',
  'service-proposal': 'Service Proposal',
  'business-plan': 'Business Plan',
};

export function getDocTypeDisplayName(documentType) {
  if (!documentType) return 'Document';
  const key = String(documentType).trim();
  if (DOC_TYPE_DISPLAY_NAMES[key]) return DOC_TYPE_DISPLAY_NAMES[key];
  const normalized = key.replace(/-/g, '_');
  if (DOC_TYPE_DISPLAY_NAMES[normalized]) return DOC_TYPE_DISPLAY_NAMES[normalized];
  const hyphenated = key.replace(/_/g, '-');
  if (DOC_TYPE_DISPLAY_NAMES[hyphenated]) return DOC_TYPE_DISPLAY_NAMES[hyphenated];
  return key
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
